import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "type"];
import React from 'react';
import { useDeprecatedClassNameStylePropsWarning } from '../../internal/deprecated-classname-style-props';
import { Box } from '../Box/Box';
import { Link } from '../Link/Link';
import { Stack } from '../Stack/Stack';
import { Text } from '../Text/Text';
/**
 * Possible product types that can be used to modify the Editorial Standards message.
 * More can be added should the need arise.
 * product types: https://github.com/NerdWallet/js-nw-api-sdk/blob/master/src/marketplace-sdk/constants.js#L35-L43
 */

var ADDITIONAL_MESSAGES = {
  investing: 'The investing information provided on this page is for educational purposes only. NerdWallet does not offer advisory or brokerage services, nor does it recommend or advise investors to buy or sell particular stocks, securities or other investments.'
};

/**
 * Displays NerdWallet's standardized editorial standards.
 */
export var EditorialStandards = function EditorialStandards(_ref) {
  var className = _ref.className,
      type = _ref.type,
      props = _objectWithoutProperties(_ref, _excluded);

  useDeprecatedClassNameStylePropsWarning('EditorialStandards', {
    className: className
  });
  return /*#__PURE__*/React.createElement(Box, _extends({
    "data-currency": "EditorialStandards",
    backgroundColor: "neutral-lightest",
    padding: "2",
    className: className
  }, props), /*#__PURE__*/React.createElement(Stack, {
    dividers: 2,
    spacing: 2
  }, /*#__PURE__*/React.createElement(Text, {
    size: "x-small",
    component: "p",
    light: true
  }, "Many or all of the products featured here are from our partners who compensate us. This may influence which products we write about and where and how the product appears on a page. However, this does not influence our evaluations. Our opinions are our own. Here is a list of", ' ', /*#__PURE__*/React.createElement(Link, {
    href: "https://www.nerdwallet.com/blog/our-partners/"
  }, "our partners"), ' ', "and", ' ', /*#__PURE__*/React.createElement(Link, {
    href: "https://www.nerdwallet.com/blog/advertiser-disclosure/"
  }, "here's how we make money"), "."), type && /*#__PURE__*/React.createElement(Text, {
    size: "x-small",
    light: true,
    component: "p"
  }, ADDITIONAL_MESSAGES[type])));
};
EditorialStandards.displayName = 'EditorialStandards';